import PendingUsers from '../../../modules/pending-users/containers/pending-users';

export default {
  path: ':organization/pending',
  title: 'Pending Members',
  indexRoute: {
    component: PendingUsers,
  },
};
